/* Add startDate, endDate, startTime, endTime for Outlook Integration  Mar 13, 2022 */
/* Add Pdf Reports Mar 25, 2023 */
/* Add changes for filtering use object and replace valFn with valFmtFn Oct 28, 2023 */
/* Add activityCost Nov 4, 2023 */
/* Add fn_timeFmt Dec 2, 2023 */
/* Amend for Front End Pagination Sep 12, 2024 */
/* Add m_searchMode for search Oct 5, 2024 */
/* Amend for Performance on Tasks Quick Filters Dec 21, 2024 */
/* Add readOnly, required columns Jan 25, 2025 */
/* Add required Indicator Feb 15, 2025 */
/* Add tableEdit events to toolbar call Mar 22, 2025 */
/* Add Gantt View for Opportunity Activities Aug 14, 2026 */
/* Add Gantt View for Account Activities Aug 27, 2026 */
/* Add Gantt View for Calendar Activities Aug 27, 2026 */
<template lang="pug">
	div(class="kt-tasks")
		//- Toolbar
		kt-toolbar(:p_getData="m_getData" :p_cols="d_cols" :p_tableData="c_filterData" :p_refData="d_refData" :p_columns="d_cols" :p_tblId="d_id" :p_tableName="d_entityName" :p_appEntKey="p_prntRecKey" :p_ctrlKey="d_ctrlKey" :p_filterData="c_filters"
					@filters="m_filterTableData" @clearFilters="m_clearFilters" @search="m_searchMode($event)" :p_tableEdit="c_editedColumns" @save="m_saveTableEdit" @cancel="m_cancelTableEdit")
			template(v-slot:toolbar-left)
				b-button(class="btn-add" title="Add New" variant="primary" @click="m_addTask()")
					fa-icon(icon="plus")
					| Add
				b-button(class="btn-task-list" variant="none" :class="{ 'is-active': d_ctrlKey === 'TL' }" :pressed="d_ctrlKey=='TL'" @click="d_ctrlKey='TL'")
					fa-icon(icon="tasks")
					| List View
				b-button(class="btn-task-board"  variant="none" :class="{ 'is-active': d_ctrlKey === 'TB' }" :pressed="d_ctrlKey=='TB'" @click="d_ctrlKey='TB'")
					img(src="@/assets/kanban.png" style="width: 25px; height:30px;")
					| Kanban View
				b-button(v-if="['oppr','proj','cal','acct'].includes(p_prntRecKey)" class="btn-task-gantt" :class="{ 'is-active': d_ctrlKey === 'TG' }" variant="none" :pressed="d_ctrlKey=='TG'" @click="d_ctrlKey='TG'")
					img(src="@/assets/gantt.png" style="width: 25px; height:30px;")
					| Gantt View
				//- span(v-else) {{c_rec_Activity.slice(0, -1) + "ies"}}
			template(v-slot:toolbar-right-r)
				div(v-if="d_ctrlKey=='TB'" class="swimln-toggle" title="Select Swimlane")
					b-dropdown(right variant="outline-secondary")
						div(class="dropdown-item" v-for="sl in d_swimlanes" :key="sl.key" @click="d_vSwimLn.key=sl.key")
							input(type="radio" :checked="d_vSwimLn.key==sl.key")
							span {{sl.label}}
						div(class="dropdown-divider")
						div(v-for="sli in d_vSwimLn.items" :key="sli.id" class="dropdown-item" 
							@click="sli.visible = !sli.visible")
							input(type="checkbox" :checked="sli.visible")
							span {{sli.name}}
							span(v-if="sli.dragList.length" class="text-grey5") ({{sli.dragList.length}})
						template(v-slot:button-content)
							fa-icon(icon="water") 
							|  Swimlanes
			template(v-slot:toolbar-right-l v-if="p_enableCUFilter" )
				b-button(class="btn-cuFilter" :class="d_qryPrms.currentUser?'filtered':null" variant="none" 
					v-b-tooltip.hover.auto.ds500="'Filter My Activities'"
					@click="m_currentUser")
					//- fa-icon(:icon="d_qryPrms.currentUser? 'user-check' : 'user-alt'")
					fa-layers
						fa-icon(icon="user-alt")
						fa-icon(:icon="['fas', 'filter']" transform="shrink-6 up-5 left-10" v-show="d_qryPrms.currentUser")
		//- Task List
		kt-task-list(v-if="d_ctrlKey=='TL'" :p_opts="d_opts" :p_cols="d_cols" :p_data="c_filterData" :p_dataParams="d_dataParams" :p_searchMode="d_searchMode" :p_searchMatches="d_searchMatches"
		  :p_prntAppEnt="d_prntAppEnt" :p_saveTableEdit="d_saveTableEdit" :p_cancelTableEdit="d_cancelTableEditTableEdit" @editTable="m_editTable(e)" @removeEdit="m_removeEdit(e)")
		//- Task Board 
		kt-task-board(v-else-if="d_ctrlKey=='TB'" :p_cols="d_cols" :p_data="c_filterData" :p_vSwimLn="d_vSwimLn" )
		//- Task Gantt
		kt-task-gantt(v-else-if="d_ctrlKey=='TG'" :p_data="c_filterData" :p_refData="d_refData" :p_idKey="c_rec_TaskId" :p_prntRecKey="p_prntRecKey" @edit="m_editTask($event.row, $event.ix)")
		//- Pagination
		kt-pagination(:p_prntRef="{dp: d_dataParams, da: d_dataAggr}" :p_getData="m_getData" :p_isCard="d_ctrlKey == 'TB'" )

		task-rec(
			v-if="d_taskRecMode"
			ref="task-rec"
			:p_mode="d_taskRecMode"
			:p_prntRecKey="p_prntRecKey"
			:p_prntRecInfo="p_prntRecInfo"
			:p_taskData="d_taskRecData"
			:p_refData="d_refData"
			@saved="m_taskSaved"
			@closed="d_taskRecMode = d_editIx = d_taskRecData = null"
		)

</template>

<script>
import util, {fn_timeFmt,kbdpAlert, fn_humanizeLabel,fn_lkpRefIdName, fn_taskParentLkp} from "@/utils/util.js";
import {refData, fn_appEnt, userSettings} from "@/utils/ref-data.js";
import {fn_getTableData, fn_updateRecordProp, fn_deleteRecord} from "@/utils/api.js";

// import TaskRec from "@/components/Rec/TaskRec.vue";
import KTTaskList from "@/components/Ctrl/KT-TaskList.vue";
import KTTaskBoard from "@/components/Ctrl/KT-TaskBoard.vue";
import KTTaskGantt from "@/components/Ctrl/KT-TaskGantt.vue";
import KTToolbar from "@/components/Ctrl/KT-Toolbar.vue";
import KTPagination from "@/components/Ctrl/KT-Pagination.vue";

const const_taskColumns = fn_prepTaskColumns();

export default {
	name: "kt-tasks",
	components: {
		'task-rec': () => import("@/components/Rec/TaskRec.vue"),
		"kt-task-list": KTTaskList,
		"kt-task-board": KTTaskBoard,
		"kt-task-gantt": KTTaskGantt,
		"kt-toolbar": KTToolbar,
		"kt-pagination": KTPagination,
	},
	created() {
		fn_setKTTaskId(this);
		util.fn_getUserOpts(this.d_id, 'tbl').then(() => {
			fn_getOpts_Tbl(this);
			fn_getCols(this);
			fn_getData(this);
		});
		
		this.d_ktTable="kt-task-list-"+this.d_prntAppEnt.name+"Tasks";
		if(this.p_prntRecKey=='cal') this.d_ktTable="kt-task-list-calendarTasks";
		this.d_usrOpts=userSettings.userOptions;

		

	},
	mounted() {},
	data() {
		return {
			d_id: null,
			d_prntAppEnt: fn_appEnt(this.p_prntRecKey),
			d_opts: {}, //KT List (Table) Options
			d_cols: [],
			d_data: [],
			d_filters: {},
			d_dataParams: {
				offset: 0,
				limit: 200,
				order: [],
				search: null
			},
			d_dataAggr: {}, //Not being used by tasks (yet)
			d_qryPrms: this.p_qryPrms || {},
			d_refData: {},
			d_rowModal: {},

			//For Task List/Task Board
			d_editIx: null,
			d_savedId: null,
			d_deletedId: null,

			d_ctrlKey: 'TL',

			d_vSwimLn: {key: 'TS', items: []}, //Keep null here. To force initial reactivity for d_cols
			d_swimlanes: [
				{key: "TS", label: "By Activity Status"},
				{key: "TL", label: "By Activity Lead"},
				{key: "TT", label: "By Activity Type"},
				{key: "TP", label: "By Priority"}
			],
			d_loading: null, //this.$parent
			d_errMessage: null, //this.$parent

			///Task Rec Props
			d_taskRecMode: null,
			d_taskRecData: null,
			d_entityName:fn_humanizeLabel(fn_appEnt(this.p_prntRecKey).name) + " Activities",
			d_filteredValue:0,
			d_pageValue:0,
			d_filteredData:null,
			d_pageData:null,
			d_searchMode:false,
			d_searchMatches:[],
			d_usrOpts:[],
			d_ktTable:null,
			d_saveTableEdit:false,
			d_cancelTableEdit:false,
			d_editTable:false,
			d_editedColumns:[],
			
			
		};
	},
	props: {
		p_prntRecKey: String, //==> oppr, proj, acct, cal
		p_prntRecInfo: {type: Object, default: () => ({Id: null, No: null, Name: null, Team: []})},
		p_enableCUFilter: Boolean,
		p_qryPrms: Object,
		p_taskIdKey: String,
		// === TEMPORARY: OFFLINE SAMPLE DATA (start) ===
		// Passed from TaskNav when VUE_APP_USE_SAMPLE_DATA=true. Remove with TaskNav hooks.
		p_getDataFn: Function,
		// === TEMPORARY: OFFLINE SAMPLE DATA (end) ===
	},
	computed: {
		c_rec_TaskId() {
			return this.d_prntAppEnt.name + "TaskId";//=> opportunityTaskId | projectTaskId | accountTaskId | calendarTaskId
		},
		c_rec_Task() {
			return this.d_prntAppEnt.name + "Task"; //=> opportunityTask | projectTask | accountTask | calendarTask
		},
		c_rec_Activity() {
			return this.d_prntAppEnt.Name + " Activity";
		},
		c_filters() {
			var filter_data = {};
			console.log('c_filters');
			this.d_cols.forEach(col =>  {
				filter_data[col.field] = {
					name: col.title,
					data: [],
					hasRefData: false,
					range: false,
					min:null,
					max:null,
					valFmtFn:col.valFmtFn,
					datatype:col.datatype,
					date: col.field.includes('Date')||col.field.includes('UTC')
				};

				let refID = col._refId !== undefined ? col._refId : null;
				let refName = col._refName !== undefined ? col._refName : null;

				if (col && col.datatype === 'num') {
					filter_data[col.field].range = true;
				}
				
				if ('_refData' in col && col._refData && col._refData.length > 0) {
					filter_data[col.field].hasRefData = true;
					

					
						
					col._refData.forEach(obj => {
						const hasID = 'id' in obj;

						if (refID || refName && !hasID) {
							refID = refID !== null && refID !== undefined ? refID : refName.split('Name')[0]+'Id';
							refName = refName !== null && refName !== undefined ? refName : refID.split('Id')[0]+'Name';

							filter_data[col.field].data.push({
								id: obj[refID],
								name: obj[refName]
							});
						}
						else {
							filter_data[col.field].data.push({
								id: obj.id,
								name: obj.name
							});
						}
					});
				}
			});
			this.d_data.forEach(rowObject => {
				for(const key in rowObject) {
					if (filter_data[key]) {
						console.log('Key:'||key);
						if (!filter_data[key].hasRefData) {
							if(filter_data[key].valFmtFn) {
								var fmtObj={id: rowObject[key],name: filter_data[key].valFmtFn(rowObject[key])};
								if(!filter_data[key].data.find(d=>d.id==fmtObj.id)) filter_data[key].data.push(fmtObj);
							} else {
									//filter_data[key].data.push(rowObject[key]);
									if(filter_data[key].data.indexOf(rowObject[key])==-1) filter_data[key].data.push({value:rowObject[key]});
								}
						} 
						if (filter_data[key].range) {
							const min = Math.min(...filter_data[key].data);
							const max = Math.max(...filter_data[key].data);

							if (min && max) {
								filter_data[key].min=min;
								filter_data[key].max=max;
							}
						}
						
							if (filter_data[key].date) {
								var min = Math.min(...filter_data[key].data.map(d =>{ return new Date(d)}));
								var max = Math.max(...filter_data[key].data.map(d =>{ return new Date(d)}));
							if (min && max) {
								filter_data[key].min=new Date(min).toISOString().slice(0,10);
								filter_data[key].max=new Date(max).toISOString().slice(0,10);

							}
						}

					}

				}
				
			});
			
			this.d_cols.forEach(col => {
			
					if(filter_data[col.field].data.length==0) delete filter_data[col.field];
					});	
		return filter_data
		},
		c_filterData() {

		
		// Quick Filters
		var v_quickFilterData=this.d_data?[...this.d_data.filter(fn_quickFilter,this)]:[];
		this.d_dataAggr.totalCountNotFiltered = v_quickFilterData.length;
	

		// generic Filters
		var v_filteredData=v_quickFilterData.length?[...v_quickFilterData.filter(fn_genericFilter,this)]:[];			
				
				
		//- Searching
		this.d_searchMatches.length=0;
		if(this.d_searchMode) {
			this.d_filteredValue=0;
			var v_filteredSearchedData=v_filteredData.filter(fn_searchFilter,this);
			v_filteredData=[...v_filteredSearchedData];
			} 
		
			
		//- Pagination
	if(v_filteredData.length>0) {	
		if(this.d_dataParams.offset>v_filteredData.length) 
			this.d_dataParams.offset = parseInt(v_filteredData.length/this.d_dataParams.limit)*this.d_dataParams.limit;
		var v_pageStart=this.d_dataParams.offset;
		var v_pageEnd=v_pageStart+this.d_dataParams.limit;
		var v_pageData=v_filteredData.slice(v_pageStart,v_pageEnd);
		v_pageData.forEach(d=>{if(d.value) this.d_pageValue=this.d_pageValue+d.value;});
		this.d_dataAggr.totalCountFiltered = v_filteredData.length;
		this.d_filteredData=[...v_filteredData];
		this.d_pageData=[...v_pageData];
		} else {this.d_filteredData=[];
				this.d_pageData=[];
				}
				
		return v_pageData;

		},
		c_editedColumns(){return this.d_editedColumns.length>0;},
		
	},
	methods: {
		m_clearFilters(data){
			console.log("In m_clearFilters");
			this.d_filters=null;
		},
		m_filterTableData(data) {
			console.log('d_filters');
			this.d_filters = {
				...data
			};
		},
		m_getData(isRefresh) { //For Toolbar, Pagination, Task List Sort
			fn_getData(this, isRefresh);
		},
		m_currentUser() {
			let qp = this.d_qryPrms;
			qp.currentUser = !qp.currentUser;
			fn_getData(this);
		},

		m_valFmtTsk(col, row, isTB) {	//Called from taskList and taskboard
			let val = row[col.key];
			if (col.valFmtFn) return col.valFmtFn(val, col, isTB);
			return val;
		},

		//Add, Edit, Clone, Delete, Update Prop
		m_addTask(idKey, id) {
			this.d_taskRecData = idKey ? {[idKey]: id} : null; //Task Board, Status, Lead, Activity Type, Priority
			this.d_taskRecMode = 'add';
		},
		m_editTask(row, ixr) {
			this.d_taskRecMode = 'edit';
			this.d_taskRecData = row;
			this.d_editIx = ixr;
		},
		m_cloneTask(row, ixr) {
			this.d_taskRecMode = 'clone';
			this.d_taskRecData = row;
		},
		m_deleteTask(row) { //Task List, Task Board Only
			let content = {
				titleText: 'Confirm Delete',
				message1: "Are you sure you want to delete the activity?"
			};
			let cm = util.fn_getModal_confirm(this, content);

			let _this = this;

			_this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;
				let appEntNm = _this.c_rec_Task;
				let recId = row[_this.c_rec_TaskId];

				kbdpAlert.showDeleting(_this.c_rec_Activity);
				fn_deleteRecord(appEntNm, recId).then(resp => {
					if (resp.error || !resp.status) {
						let msg = `Unable to delete ${_this.c_rec_Activity}. ` + (resp.error || "");
						kbdpAlert.showErr(msg);
						return;
					}
					let ix = _this.d_data.map(x => x[_this.c_rec_TaskId]).indexOf(recId);
					_this.d_data.splice(ix, 1);

					kbdpAlert.showOk(this.c_rec_Activity + " was deleted successfully.");
				});
			});
		},
		m_updateTaskProp(recId, prop, value) { //Task Board Only
			let appEntNm = this.c_rec_Task;
			let _this = this;

			// kbdpAlert.showSaving(_this.c_rec_Activity);
			fn_updateRecordProp(appEntNm, recId, prop, value).then(resp => {
				if (resp.error || !resp.status) {
					let msg = `Unable to update ${_this.c_rec_Activity}. ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					return;
				}
				// kbdpAlert.clear();
				try {
					_this.d_data.filter(x => x[_this.c_rec_TaskId] == recId)[0][prop] = value;
				} catch (e) {
					console.log("Error Updaing d_data", e);
				}
			});
		},

		//Task Saved (Emitted From TaskRec)
		m_taskSaved(taskData) {
			if (this.d_editIx !== null) { 	//Edited Existing
				this.d_editIx = null;
				let ix = this.d_data.map(x => x[this.c_rec_TaskId]).indexOf(taskData.id);
				this.d_data.splice(ix, 1, taskData);
			}
			else { 	//Added New
				this.d_data.push(taskData);
			}
			this.d_taskRecMode = this.d_taskRecData = null;
			this.d_savedId = taskData[this.c_rec_TaskId];
			setTimeout(() => {this.d_savedId = null;}, 1500);
		},
		m_searchMode(e){if(e)
						this.d_searchMode=true;
						else{
						this.d_searchMode=false;
						this.d_searchMatches.length=0;
						}
					},
		m_saveTableEdit() {this.d_saveTableEdit=true;
		                   this.d_editedColumns=new Array();
						   },
		m_cancelEditTableEdit() {this.d_cancelTableEditTableEdit=true;
		                   this.d_editedColumns=new Array();
						   },
		m_editTable(){this.d_editedColumns.push(e);},
		m_removeEdit(){this.d_editedColumns.pop();},
		

	},
	watch: {
		d_ctrlKey(nv, ov) {
			fn_setKTTaskId(this);
			if (nv == 'TL') {
				util.fn_getUserOpts(this.d_id, 'tbl').then(() => {
					fn_getOpts_Tbl(this);

					//Reset some attribs that woud be set from TB
					const_taskColumns.forEach(cc => {
						let col = this.d_cols.filter(c => c.key == cc.key)[0];
						['noToggle', 'default', 'visible','readOnly'].forEach(k => {
							if (cc[k] === undefined) delete col[k];
							else col[k] = cc[k];
						});
					});

					fn_setColOpts(this);
				});
			}
			else if (nv == 'TB') {
				util.fn_getUserOpts(this.d_id, 'brd').then(() => {
					fn_getOpts_Brd(this);
					fn_setColOpts(this);
				});
			}
		},
		"d_vSwimLn.key"(nv, ov) {
			fn_setKTTaskId(this);
			util.fn_getUserOpts(this.d_id, 'brd').then(() => {
				fn_getOpts_Brd(this);
				fn_setColOpts(this);
			});
		},
		p_qryPrms(nv, ov) {
			//Object.keys(nv || {}).forEach(k => this.d_qryPrms[k] = nv[k]);
			this.d_qryPrms={...nv};
			this.d_dataParams.offset = 0;
			//fn_getData(this);
		},
	}
};



export {fn_getTaskColumns as fn_getColumns};

function fn_setKTTaskId(vc) {
	let ck = vc.d_ctrlKey;
	let cl = ck == "TL" ? "list-" : ck == "TB" ? "board-" : ck == "TG" ? "gantt-" : ""; // TL, TB, TG
	let rk = vc.c_rec_Task + (vc.p_prntRecInfo.Id ? "" : "s"); //opportunityTask, projectTask, accountTask, opportunityTasks, projectTasks, accountTasks
	let tik = vc.p_taskIdKey || '';
	let slk = ck == "TB" ? "-" + vc.d_vSwimLn.key : "";
	vc.d_id = "kt-task-" + cl + rk + tik + slk;
	
	
}
function fn_prepTaskColumns() {
	let cols = [
		{
			key: "taskName",
			field: "taskName",
			title: "Activity Name",
			default: true,
			editOnClick: true,
			sortable:true,
			__dbvw: true, //Dashboard View
			datatype:"text",
		},
		{
			key: "taskDescription",
			field: "taskDescription",
			title: "Description",
			hideInForm: false,
			__dbvw: true,
			datatype:"text",
		},
		{
			key: "taskLeadId",
			field: "taskLeadId",
			title: "Activity Lead",
			default: true,
			_refId: "teamMemberId",
			_refName:"teamMemberName",
			icon: "user",
			hideInForm: false,
			sort:true,
			__dbvw: true,
			datatype:"text",
			
		},
		{
			key: "taskTypeId",
			field: "taskTypeId",
			title: "Activity Type",
			_refData: refData.taskTypes,
			icon: "cubes",
			hideInForm: true,
			sortable:true,
			__dbvw: true,
			datatype:"text",
		},
		{
			key: "taskStatusId",
			field: "taskStatusId",
			title: "Status",
			default: true,
			_refData: refData.taskStatuses,
			iconFn: val => {
				let ts = refData.taskStatus(val.taskStatusId, null).name;
				switch (ts) {
					case "To Do": return "exclamation-circle";
					case "In Progress": return "play-circle";
					case "Completed": return "check-circle";
					case "On Hold": return "pause-circle";
					case "Canceled": return "ban";
				}
			},
			hideInForm: false,
			sortable:true,
			__dbvw: true,
			datatype:"text",
		},
		{
			key: "dueDate",
			field: "dueDate",
			default: true,
			icon: 'calendar-day',
			tdClassFn: (val) => {
				let ts = refData.taskStatus(val.taskStatusId, null).name;
				let tdip = ["To Do", "In Progress"].indexOf(ts) > -1;
				if (!tdip) return null;

				let dd = util.fn_dateDiff(val.dueDate, null);

				return dd < 0 ? 'past-due' : dd == 0 ? 'due-today' : dd < 4 ? 'due-soon' : null;
			},
			hideInForm: false,
			sortable:true,
			__dbvw: true,
		    datatype:"date",
		},
		{
			key: "completionDate",
			field: "completionDate",
			default: true,
			iconFn: (val) => {
				let ts = refData.taskStatus(val.taskStatusId, null).name;
				switch (ts) {
					case "Completed": return "calendar-check";
					default: return ['far', 'calendar-check'];
				}
			},
			hideInForm: false,
			datatype:"date",
		},
		{
			key: "percentComplete",
			field: "percentComplete",
			title: "% Complete",
			valFmtFn: (val, col, isTB) => {
				if (val) return val + "%" + (isTB ? ' Complete' : '');
			},
			hideInForm: true,
			datatype: 'num',
			sortable:true,
			__dbvw: true,
			datatype:"num",
		},
		{
			key: "priority",
			field: "priority",
			_refData: refData.taskPriorities,
			_refId: "value",
			_refName: "text",
			hideInForm: true,
			datatype: 'num',
			sortable:true,
			__dbvw: true,
			datatype:"text",
		},
		{
			key: "taskDetails",
			field: "taskDetails",
			title: "Details",
			noToggle: true,
			hideInForm: false,
			datatype:"text",
		},

		{
			key: "addedById",
			field: "addedById",
			_refId: "teamMemberId",
			tdClass: "td-usr",
			tbClass: "tb-usr",
			icon: "plus",
			datatype:"text",
		},
		{
			key: "addedUTC",
			field: "addedUTC",
			tdClass: "td-dtm",
			tbClass: "tb-dtm",
			icon: "plus",
			datatype:"date",
		},
		{
			key: "updatedById",
			field: "updatedById",
			_refId: "teamMemberId",
			tdClass: "td-usr",
			tbClass: "tb-usr",
			icon: "edit",
			datatype:"text",
		},
		{
			key: "updatedUTC",
			field: "updatedUTC",
			tdClass: "td-dtm",
			tbClass: "tb-dtm",
			icon: "edit",
			datatype:"date",
		},
		{
			key: "startDate",
			field: "startDate",
			title: "Start Date",
			hideInForm: false,
			sortable:false,
			__dbvw: true,
			datatype:"date",
		},
		{
			key: "endDate",
			field: "endDate",
			title: "End Date",
			hideInForm: false,
			sortable:false,
			__dbvw: true,
			datatype:"date",
		},
		{
			key: "startTime",
			field: "startTime",
			title: "Start Time",
			hideInForm: false,
			sortable:false,
			__dbvw: true,
			valFmtFn: val => {return val?fn_timeFmt(val):null;},
			datatype:"text",
		},
		{
			key: "endTime",
			field: "endTime",
			title: "End Time",
			hideInForm: false,
			sortable:false,
			__dbvw: true,
			valFmtFn: val => {return val?fn_timeFmt(val):null;},
			datatype:"text",
		},
		{
			key: "activityCost",
			field: "activityCost",
			title: "Activity Cost",
			valFmtFn: val => {return val?'$'+val.toLocaleString('en'):null;},
			showAggr: 'sum',
			datatype: 'num',
			__dbvw: true, //Dashboard View
		},
	/*
		{
			key: "taskChecklist",
			field: "taskChecklist",
			title: "Checklist",
			icon: ['far', 'check-square'],
			valFmtFn: (val) => {
				if (!val || val.length == 0) return null;
				let donelen = val.filter(x => x.done).length;
				return `${donelen} of ${val.length} Done`;
			},
			hideInForm: false,
			datatype:"text",
		},
		{
			key: "taskAssignees",
			field: "taskAssignees",
			title: "Assignee(s)",
			_refId: "teamMemberId",
			valFmtFn: (val, col) => {
				return fn_lkpRefIdNameMulti(col, val);
			},
			icon: fn_appEnt("team").icon,
			hideInForm: false,
			datatype:"text",
		},
		{
			key: "externalContacts",
			field: "externalContacts",
			title: "External Contact(s)",
			_refId: "externalContactId",
			valFmtFn: (val, col) => {
				return fn_lkpRefIdNameMulti(col, val);
			},
			icon: fn_appEnt("extr").icon,
			hideInForm: true,
			datatype:"text",
		},
		*/
		
	];
	
	
	cols.forEach(col => {
		if (!col.title) col.title = util.fn_humanizeLabel(col.key);
		//need to set values for reactivity 
		col.visible = col.default === true;
		col.width = null;
		col.sort = null;
		col.resizing = null;



		if (col.title.endsWith(" Date")) {
			col.valFmtFn = (val) => {return util.fn_fmtDt(val);};
		}
		else if (col.title.endsWith(" UTC")) {
			col.valFmtFn = (val) => {return util.fn_fmtDtm(val);};
		}

		if (col._refData) {
			col.valFmtFn = (val) => {
				return fn_lkpRefIdName(col._refData, col, val); //Local Ref Data
			};
		}
		
		

	});
	return cols;
}
function fn_getTaskColumns() {
	return const_taskColumns.map(col => ({...col}));
}




function fn_getOpts_Tbl(vc) {
	let opts = {
		enableEdit: true,
		staticHeight: null,
		maxHeight: null,
		width: null,
	};

	vc.d_opts = opts;


	//let usrOpts = userSettings.userOptions;

	opts.colOpts = {
		visible: vc.d_usrOpts['tableColumnsVisible'][vc.d_id],
		widths: vc.d_usrOpts['tableColumnWidths'][vc.d_id],
		sorts: vc.d_usrOpts['tableColumnSorts'][vc.d_id],
	};

	opts.width = opts.colOpts.widths._tblW || null;

	let dpOrder = vc.d_dataParams.order = [];
	let sorts = opts.colOpts.sorts;
	Object.keys(sorts).forEach(k => {
		dpOrder.push({col: k, dir: sorts[k]});
	});
}
function fn_getOpts_Brd(vc) {
	let opts = {};
	vc.d_opts = opts;
	//let usrOpts = userSettings.userOptions;
	opts.colOpts = {
		visible: vc.d_usrOpts['boardFieldsVisible'][vc.d_id],
	};
}

function fn_getCols(vc) {
	let cols = fn_getTaskColumns();

	//Column for opportunityId/projectId/accountId
	//For All Tasks --> util.fn_taskCol_ActivityScope
	if (!vc.p_prntRecInfo.Id && vc.p_prntRecKey != 'cal') {
		cols.unshift({
			key: vc.d_prntAppEnt.idKey,
			field: vc.d_prntAppEnt.idKey,
			title: vc.d_prntAppEnt.Name,
			tbClass: "tb-prnt",
			visible: true,
			default: true,
			width: null,
			sort: null,
			resizing: null,
			datatype: 'num',

			linkFn: (val) => {
				let lkp = fn_taskParentLkp(val, vc.d_refData, vc.d_prntAppEnt);
				return {path: util.fn_hrefVwRec(vc.d_prntAppEnt.key, lkp.prntNo)};
			},
			valFmtFn: (val) => {
				let lkp = fn_taskParentLkp(val, vc.d_refData, vc.d_prntAppEnt);
				return util.fn_recLbl(lkp.prntNo, lkp.prntName);
			},
			valFn: (val) => {
				let lkp = fn_taskParentLkp(val, vc.d_refData, vc.d_prntAppEnt);
				return util.fn_recLbl(lkp.prntNo, lkp.prntName);
			}
		});
	}

	//Column for [opportunity/project/account/Calendar]ActivityId
	cols.unshift({
		key: vc.c_rec_TaskId,
		field: vc.c_rec_TaskId,
		title: "Activity Id",
		tbClass: "tb-id",
		icon: "key",
		visible: null,
		default: null,
		width: null,
		sort: null,
		resizing: null,
	});
	vc.d_cols = cols;

	fn_setColOpts(vc);
}
function fn_setColOpts(vc) {
	let colOpts = vc.d_opts.colOpts;
	let cov = colOpts.visible || {};
	
	let readOnlyColumns=[];
	let requiredColumns=[];
	let requiredColumnsObj=[];
	let tableReadOnlyColumns=vc.d_usrOpts['tableReadOnlyColumns'];
	let tableRequiredColumns=vc.d_usrOpts['tableRequiredColumns'];
	if(tableReadOnlyColumns) readOnlyColumns=tableReadOnlyColumns[vc.d_ktTable]||[];
	if(tableRequiredColumns) requiredColumnsObj=tableRequiredColumns[vc.d_ktTable]||[];
	requiredColumns=requiredColumnsObj.map(c=>{return c.field;});
	

	
	

	vc.d_cols.forEach(col => {
		if (cov._all)
			col.visible = true;
		else if (cov._defaults)
			col.visible = (col.default === true);
		else if (cov[col.key] !== undefined)
			col.visible = cov[col.key];
		else
			col.visible = (col.default === true);

		if (colOpts.widths) col.width = colOpts.widths[col.key] || null;//N/A for board
		if (colOpts.sorts) col.sort = colOpts.sorts[col.key] || null; //N/A for board
		
		//- ReadOnly, super Read only, Super visible.
		col['readOnly']=false;
		col['required']=false;
		if(readOnlyColumns.includes(col.field)) col.readOnly=true;
		if(requiredColumns.includes(col.field)) col.required=true;
		
		
		if(!col.tdClassFn) col.tdClassFn = (val) => {return null;};
		
		if(col.field=='dueDate') {
			console.log('For dueDate');
			console.log(col);
			col.tdClassFn = (val) => {
				let ts = refData.taskStatus(val.taskStatusId, null).name;
				let tdip = ["To Do", "In Progress"].indexOf(ts) > -1;
				if (!tdip) return null;

				let dd = util.fn_dateDiff(val.dueDate, null);

				return dd < 0 ? 'past-due' : dd == 0 ? 'due-today' : dd < 4 ? 'due-soon' : null;
			};
		}

		
		
	});
}


function fn_getData(vc, isRefresh) {
	// debugger;
	vc.d_loading = true;

	let appEntNm = vc.c_rec_Task + "s";

	let dp = vc.d_dataParams;
	let reqPrms = {offset: 0, limit: 1000, search: dp.search};
	if (dp.order.length) reqPrms.order = dp.order.map(x => x.col + '.' + x.dir).join(',');
	if (isRefresh === true) reqPrms.refresh = true;

	let qp = vc.d_qryPrms;
	//if (qp) {Object.keys(qp).forEach(k => (reqPrms[k] = qp[k]));}
	if (qp &&qp.dashboardId) {Object.keys(qp).forEach(k => (reqPrms[k] = qp[k]));}

	let recId = vc.p_prntRecInfo.Id;
	if (recId) reqPrms[vc.d_prntAppEnt.idKey] = recId;

	// debugger;
	// === TEMPORARY: OFFLINE SAMPLE DATA (start) ===
	if (vc.p_getDataFn) {
		vc.p_getDataFn(reqPrms).then(resp => {
			fn_loadDataRoutine(vc, resp);
		});
		return;
	}
	// === TEMPORARY: OFFLINE SAMPLE DATA (end) ===
	fn_getTableData(appEntNm, reqPrms).then(resp => {
		fn_loadDataRoutine(vc, resp);
	});
}
function fn_loadDataRoutine(vc, resp) {
	if (resp.errorMessage) {
		vc.d_errMessage = resp.errorMessage;
		vc.d_loading = false;
		return;
	}
	vc.d_data = resp.rows;
	console.log('DB data');
	vc.d_refData = resp.refData;
	vc.d_dataAggr.totalCountNotFiltered = resp.totalCountNotFiltered;
	vc.d_dataAggr.totalCountFiltered = resp.totalCountFiltered; //Important, not the same as resp.rows.length
	vc.d_dataAggr.colAggrNotFiltered = resp.colAggrNotFiltered;


	vc.d_cols.forEach(col => {
		if (!col._refId) return;
		
		let rd=[];
		if(vc.d_refData){
		rd = vc.d_refData[col._refId];

		if (!rd && col._refData) return;
		else if (!rd) {
			rd = vc.d_refData[col._refId] = [];
			}
		}
		col._refData = rd;//Remote Ref Data, Set reference here at the col here to avoid cpu cycles for each row/card rendered

		if (col.valFmtFn) return;

		col.valFmtFn = (val) => {
			return fn_lkpRefIdName(col._refData, col, val);
		};
	});
	vc.d_errMessage = null;
	vc.d_loading = false;
}
function fn_quickFilter(data){
			
			//- Team Member Filter
				if(this.d_qryPrms.teamMemberId){
					var teamMemberId=this.d_qryPrms.teamMemberId;
					var teamMembers=[];
					if(data.taskAssignees) teamMembers=data.taskAssignees.map(t=>{return t.teamMemberId});
					if(teamMemberId != data.taskLeadId &&
						!(teamMembers.includes(teamMemberId)))
					return false;
					}
					
			//- Quick Status Filter
				if(this.d_qryPrms.taskStatusIds) {
					var taskStatusIdArray=JSON.parse(this.d_qryPrms.taskStatusIds);
					if(!(taskStatusIdArray.includes(data.taskStatusId))){
						return false;
						}
				}

	
	return true;
				
}
function fn_genericFilter(data){
				for (const key in this.d_filters) {
				
					if (this.d_filters[key] && this.d_filters[key].range &&
						!(this.d_filters[key].min <= data[key] && data[key] <= this.d_filters[key].max)
					) {
						return false;
					}	

					if (this.d_filters[key] && this.d_filters[key].date &&
						!((new Date(data[key])) >= (new Date(this.d_filters[key].min)) &&
						(new Date(data[key])) <= (new Date(this.d_filters[key].max)))
					) {
						return false;
					}
					
					if (this.d_filters[key] && this.d_filters[key].length && 
						!~this.d_filters[key].indexOf(data[key])
					) {
						return false;
					}

				}
				
				

								
	
	
	return true;
				
}
function fn_searchFilter(data){
	var searchMatched=false;

	var searchString;
	var searchedValue;
	var datatype;
	var field;
	var valFmtFn;
	var fn_hrefAppLink;
					
					
					
	searchString=this.d_dataParams.search;
	if(searchString.endsWith("|")) searchString=searchString.substr(0, searchString.length-1);
					
	var regex= new RegExp(searchString,'i');

	this.d_cols.filter(c=>c.visible).forEach(col => {
					
					field=col.field;
					datatype=col.datatype;
					valFmtFn=col.valFmtFn;
					fn_hrefAppLink=col.fn_hrefAppLink;
					if(data[field]){
						searchedValue=data[field];
						if(fn_hrefAppLink) searchedValue=data[field].name;
						if(valFmtFn) searchedValue=valFmtFn(data[field]);
						if(datatype=='num'||datatype=='number') searchedValue=data[field].toString();
						
						
						console.log(`searching for ${searchString} in ${searchedValue}`);
						
						if(regex.test(searchedValue)){
							this.d_searchMatches.push({row:data[this.c_rec_TaskId],col:field});
							searchMatched=true;
							//console.log("search Matched:"+data[this.c_rec_TaskId]);
							}
						
						}	
					});
				
				if(this.d_searchMode&&!searchMatched) return false;
					
				if(data.value) this.d_filteredValue=this.d_filteredValue+data.value;
				return true;
}



</script>

<style lang="less">
.kt-tasks {
	margin-top: 0.25em;
	div.loading,
	div.error,
	div.nodata {
		width: 100%;
		font-size: 1em;
		text-align: center;
		padding: 0.5em 0;
	}

	.btn-add,
	.btn-task-list,
	.btn-task-board,
	.btn-task-gantt {
		font-size: 0.8em;
		padding: 0.1em 0.4em;
		margin-right: 0.5em;
		svg {
			margin-right: 0.2em;
		}
	}
}

// #bm-kt-task select.prioirty,
#bm-kt-task select.prioirty option,
.kt-tasks .kt-task-board .drag-item > div[title="Priority"] > span {
	&.pr-0,
	&[value=""] {
		color: #000;
	}
	&.pr-5,
	&[value="5"] {
		color: #dc3545;
		font-weight: bold;
	}
	&.pr-4,
	&[value="4"] {
		color: #dc3545;
	}
	&.pr-3,
	&[value="3"] {
		color: #000;
	}
	&.pr-2,
	&[value="2"] {
		color: #60a871;
	}
	&.pr-1,
	&[value="1"] {
		color: #60a871;
	}
}
.btn-task-gantt.is-active,
.btn-task-list.is-active,
.btn-task-board.is-active {
  text-decoration: underline;
  color: #0078d4; /* optional highlight */
}
</style>